module.exports = __webpack_public_path__ + "static/media/zumba.3a900f14.webp";